export default "__VITE_ASSET__DMXa9$57__"